const messages = {
  validation: {
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    required: { id: 'admin/promotions.form.validation.required' },
  },
}

export default messages
